<template>
  <Modal :style="buyNumberModalIsOpen ? 'display: flex' : 'display: none'" :show="buyNumberModalIsOpen"
         :scrollable="true" modal-class="modal-buy-number" @close="closeModal">
    <template #body>
      <button class="buy-number-modal-close-btn" @click="closeModal"></button>
      <div class="buy-number-title-vue">
        {{ getLocalization('You have successfully sent a request for a number, please wait...') }}
      </div>
      <BowerSpiner v-if="buyNumberModalIsOpen"></BowerSpiner>
      <div class="buy-number-content-vue row g-3">
        <div class="buy-number-content-first col-lg-6 col-12">
          <p :class="isChineseLanguage ? 'ch-buy-number-modal-text' : ''">
            {{ getLocalization('We are already looking for a number for you, recommended waiting time 1-2 min.') }}
          </p>
          <p class="pt-3">
            {{ getLocalization('If waiting takes too long, try the countries we recommend') }}
          </p>
        </div>
        <div class="buy-number-content-second col-lg-3 col-12">
          <img class="buy-number-arrow" src="/img/svg/common/arrow.svg" alt=""/>
        </div>
        <div class="buy-number-content-third col-lg-3 col-12">
          <a class="button primary fw-bolder orange another-country" v-if="serviceRouteSlug"
             :href="serviceRoute + '/' + serviceRouteSlug">
            {{ getLocalization('Choose another country') }}
          </a>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../components/table/modalNew.vue";
import BowerSpiner from "./../bower-spiner.vue";

export default {
  name: "buyNumberModal",
  components: {
    Modal,
    BowerSpiner
  },
  props: {
    buyNumberModalIsOpen: {
      type: Boolean,
      required: true
    },
    isChineseLanguage: {
      type: Boolean,
      required: true
    },
    serviceRoute: {
      type: String,
      required: true
    },
    serviceRouteSlug: {
      type: String,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>
<style scoped></style>
